import React from "react";
import Divider from "./../../assets/images/head-to-head-divider.svg";
import { HeadToHeadPlayCardProps } from "./headToHeadPlayCard.types";
import clsx from "clsx";
import { formatCurrencyToUsd } from "../../utils/format";

const HeadToHeadPlayCard: React.FC<HeadToHeadPlayCardProps> = ({
  player1Stashlink,
  player2Stashlink,
  goal,
  player1Score,
  player2Score
}) => {
  const player1 = player1Stashlink?.user;
  const charity1Logo = player1Stashlink?.campaign.charity?.imageUrl;
  const player2 = player2Stashlink?.user;
  const charity2Logo = player2Stashlink?.campaign.charity?.imageUrl;

  return (
    <>
      <div className="flex flex-col items-center justify-center text-center w-full max-w-md rounded-lg">
        <div className="mb-3">
          <div className="text-primary-l1 text-[22px] font-extrabold leading-[120%] font-primary">
            {formatCurrencyToUsd((player1Score ?? 0) + (player2Score ?? 0))}
          </div>
          <div className="text-sm font-base-white font-secondary font-medium">raised of {formatCurrencyToUsd(goal)} goal</div>
        </div>

        <div className="relative w-full grid grid-cols-2">
          <div>
            <div className="relative">
              <img
                src={player1?.profilePhoto}
                alt={player1?.fullName}
                className={clsx("w-full mr-0.5 h-[193px] object-cover rounded-tr-[64px]")}
              />
              <div className="max-w-4/5 absolute text-[17px] font-primary text-shadow-custom font-bold text-base-white leading-[120%] bottom-4 left-4">
                {player1?.fullName}
              </div>
              <div className="relative w-full bg-grey bg-opacity-30">
                <div
                  className="h-3 bg-primary-l1 rounded-tr-full rounded-br-full"
                  style={{ width: `${((player1Score ?? 0) / (goal ?? 0)) * 100}%` }}
                />
              </div>
            </div>
            <div className="relative text-left pt-[10px] pl-5 pb-0">
              <p className="text-primary-l1 text-lg font-extrabold font-secondary">{formatCurrencyToUsd(player1Score ?? 0)}</p>
              <p className="text-sm text-grey font-secondary mb-3 -mt-1">raised for</p>
              <img
                src={charity1Logo}
                alt="charity-logo"
                className="size-[100px] rounded-full mb-[5px] border border-1 border-black object-cover"
              />
              <p className="text-base text-base-white font-medium w-5/6">{player1Stashlink?.campaign?.charity?.name}</p>
              <a href={player1Stashlink?.campaign?.charity?.website} target="_blank" rel="noopener noreferrer">
                <p className="text-base text-light-grey underline font-secondary mb-4">Learn more</p>
              </a>
            </div>
          </div>

          <div>
            <div className="relative">
              <img
                src={player2?.profilePhoto}
                alt={player2?.fullName}
                className={clsx("w-full h-[193px] object-cover rounded-tl-[64px]")}
              />
              <div className="max-w-4/5 absolute text-[17px] font-primary text-shadow-custom font-bold text-base-white leading-[120%] bottom-4 right-4">
                {player2?.fullName}
              </div>
              <div className="relative w-full bg-grey bg-opacity-30 flex flex-row justify-end">
                <div
                  className="h-3 bg-primary-l1 rounded-tl-full rounded-bl-full"
                  style={{ width: `${((player2Score ?? 0) / (goal ?? 0)) * 100}%` }}
                />
              </div>
            </div>
            <div className="relative text-right flex items-end flex-col pt-[10px] pr-5 pb-0">
              <p className="text-primary-l1 text-lg font-extrabold font-secondary">{formatCurrencyToUsd(player2Score ?? 0)}</p>
              <p className="text-sm text-grey font-secondary mb-3 -mt-1">raised for</p>
              <img
                src={charity2Logo}
                alt="charity-logo"
                className="object-cover size-[100px] rounded-full mb-[5px] border border-1 border-black"
              />
              <p className="text-base text-base-white font-medium w-5/6">{player2Stashlink?.campaign?.charity?.name}</p>
              <a href={player2Stashlink?.campaign?.charity?.website} target="_blank" rel="noopener noreferrer">
                <p className="text-base text-light-grey underline font-secondary mb-4">Learn more</p>
              </a>
            </div>
            <img src={Divider} alt={Divider} className="absolute left-2/4 -translate-x-2/4 top-64" />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeadToHeadPlayCard;
